import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import TranslateButton from "../../TranslateButton/TranslateButton";
// import AuditNotice from "../../../images/Notice/Notice.jpeg";
import "../../../style/noticeBoard/officeNotice.css";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const OfficeNotice = () => {
  useEffect(() => {
    document.title = `AshroyAngon | Office Notice`;
  }, []);

  const shareUrl = "https://ashroyangon.org/noticeBoard/office-notice";

  return (
    <>
      <Navbar />
      <TranslateButton />

      <div className="office_notice_section">
        {/* Header Background Part Start */}
        <div className="header_background">
          <div className="container wrapper">
            <h2>Office Notice</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div>
        {/* Header Background Part End */}

        <div className="office_notice_wrapper">
          <div className="container">
            <div className="content_wrapper">
              <h3>There is no official notice issued at this time</h3>
              {/* <div className="notice">
                <p>Date: 07.07.2024</p>
                <div className="image">
                  <img src={AuditNotice} loading="lazy" alt="" />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default OfficeNotice;
